"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceCenterService = void 0;
const ResourceCenterService_types_1 = require("./types/ResourceCenterService.types");
const CATEGORIES = [
    ResourceCenterService_types_1.Subtopic.EducationPlanning,
    ResourceCenterService_types_1.Subtopic.FamilyAndEstate,
    ResourceCenterService_types_1.Subtopic.HealthAndInsurance,
    ResourceCenterService_types_1.Subtopic.Investing,
    ResourceCenterService_types_1.Subtopic.PersonalFinance,
    ResourceCenterService_types_1.Subtopic.Retirement,
    ResourceCenterService_types_1.Subtopic.Taxes
];
const ENDPOINTS = {
    qa: 'https://websearch.qa.ampf.com/QA-Ameriprise/search',
    prod: 'https://websearch.ampf.com/PROD-Ameriprise/search'
};
const CONSUMER_IDS = {
    qa: 'a0056112',
    prod: 'a0056099'
};
function getEnvironment() {
    const hostname = window.location.hostname;
    return hostname.includes('qa') ? 'qa' : 'prod';
}
class ResourceCenterService {
    static async fetchDefaultTopics() {
        const response = await fetch('/halapi/selection:valuelist?_scope=/content/documents/administration/value-lists/ameriprise/resource-center/sub-topic/financial-goals');
        const result = await response.json();
        return result._embedded.documents[0].listitem.map((item) => ({
            key: item.key,
            value: item.label,
            checked: false
        }));
    }
    static async fetchResourceCenterData(categories, query = ' ') {
        const env = getEnvironment();
        const categoriesToUse = categories && categories.length > 0 ? categories : CATEGORIES;
        const categoryFilter = categoriesToUse
            .map(category => `enriched_html.entities.text::${category}`)
            .join('|');
        const filter = `enriched_html.entities.model_name::foundational_topic,(${categoryFilter})`;
        try {
            const response = await fetch(ENDPOINTS[env], {
                method: 'POST',
                headers: {
                    'x-websearch-consumer': CONSUMER_IDS[env],
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    query,
                    filter,
                    xReturn: ['title', 'metadata.source.url', 'enriched_html'],
                    passages: { enabled: false }
                })
            });
            if (!response.ok) {
                console.error('Resource Center Fetch failed');
                return null;
            }
            const data = await response.json();
            const resourceCenterResults = data.results.map((result) => {
                const entities = result.properties.enriched_html[0].entities;
                const getEntityText = (modelName) => entities.find(e => e.model_name === modelName)?.text || '';
                return {
                    url: result.metadata.source.url,
                    title: result.properties.title,
                    subtopic: getEntityText('sub_topic'),
                    description: getEntityText('Omni_description'),
                    imageUrl: getEntityText('hero-image'),
                    results: data.results,
                    count: data.matchingResults
                };
            });
            return resourceCenterResults;
        }
        catch (error) {
            console.error('Network error fetching resource center data');
            return null;
        }
    }
}
exports.ResourceCenterService = ResourceCenterService;
